import React from 'react'
// import material ui
import { makeStyles } from '@material-ui/core/styles';
import { BarChart } from '@mui/x-charts/BarChart';
// import i18n
import { useTranslation } from 'react-i18next';
// import components
import LinkTo from '../../../_components/LinkTo';
// import moment
import moment from 'moment';

const useStyles = makeStyles(theme => ({
    item: {
        height: "100%",
        paddingTop: 32,
        paddingBottom: 32,
        [theme.breakpoints.down(476)]: {
            paddingTop: 16,
            paddingBottom: 16,
        },
    },
    title_link: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 10,
    },

    chart: {
        width: "100%",
        position: "absolute",
        left: 0,
        top: 0,
    },

    chartHover: {
        fill: "rgb(255, 190, 0)",
        transition: "0.5s",
        "&:hover": {
            fill: "#1F1F1F",
        },
    },
}));

const DashboardReturnsGoods = (props) => {
    const { data, notAllManagerDataCondition, currency } = props;
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={`dashboard-card ${classes.item}`}>
            {notAllManagerDataCondition === true ? <div className="dashboard-card-empty">{t('common:fill_user_details_label')}</div> : data?.length < 5 ? (
                <div className="dashboard-card-empty">{t('common:cannot_show_chart_label')}</div>
            ) : null}
            <div className={classes.title_link}>
                <div style={{
                    display: "grid",
                    gap: 6
                }}>
                    <h2 className="dashboard-title">{t('common:return_goods_label')}</h2>
                    <p className="dashboard-text">{t('common:last_month_label')}</p>
                </div>
                <LinkTo title={t('common:read_mode_label')} adaptive={true} path={"/profile/returns/"} />
            </div>
            <div style={{
                position: "relative",
                height: "150px",
            }}>
                <div className={classes.chart}>
                    <BarChart
                        series={[{
                            id: 'auto-generated-id-0',
                            data: data?.length < 5 ? [4, 3, 5, 4, 10] : data?.map((item) => item?.price_sum),
                            valueFormatter: (el) => `${currency} ${el}`,
                        }]}
                        xAxis={[{
                            scaleType: 'band',
                            data: data?.length < 5 ? [4, 3, 5, 4, 10]?.map((_, index) => index + 1) : data?.map((_, index) => index + 1),
                            valueFormatter: (el) => `${data?.length < 5 ? el : moment(data[el - 1]?.order_date)?.format("DD.MM.YYYY")}`,
                        }]}
                        colors={["#1F1F1F"]}
                        sx={{ width: '100%' }}
                        height={200}
                        slots={{
                            bar: (props) => {
                                const { style } = props;
                                const str = JSON.stringify(style);
                                const arr = JSON.parse(str);
                                const { x, y, height, width } = arr;
                                return <rect
                                    className={`MuiBarElement-root MuiBarElement-series-auto-generated-id-0 css-trudc8-MuiBarElement-root ${classes.chartHover}`}
                                    rx="20"
                                    style={{
                                        transform: `translate3d(${x}px, ${y}px, 0px)`,
                                        width: `${width}px`,
                                        height: `${height}px`,
                                    }}
                                ></rect>;
                            },
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default DashboardReturnsGoods